module.exports = __webpack_public_path__ + "img/medicines-types.bcebb7c6.svg";